document.addEventListener('DOMContentLoaded', function() {
	const form = document.getElementById('requests-form');
	const searchInput = document.getElementById('search-input');
	const toggleAll = document.getElementById('toggle-all');
	const REQUEST_ROW_SELECTOR = '.js-request-row';
	const REQUEST_CHECKBOX_SELECTOR = '.request-checkbox';
	const btnSelectToday = document.querySelector('button[name="select_today"]');

	if (!form || !toggleAll) return;

	// Обновление сессии через AJAX
	async function updateSelection(id, isChecked) {
		try {
			await BX.ajax.runComponentAction(
				'main:repair',
				'updateSelection',
				{
					mode: 'ajax',
					data: {
						id: id,
						checked: isChecked.toString()
					}
				}
			);
		} catch (error) {
			console.error('Ошибка обновления:', error);
			return false;
		}
		return true;
	}

	// Обработка чекбоксов
	function handleCheckboxChange(e) {
		const checkbox = e.target;
		if (!checkbox.classList.contains('request-checkbox')) return;

		updateSelection(checkbox.value, checkbox.checked)
			.then(success => {
				if (!success) {
					checkbox.checked = !checkbox.checked; // Откат при ошибке
				}
				updateToggleAllState();
			});
	}

	// "Выделить все" с AJAX
	async function handleToggleAll(e) {
		const isChecked = e.target.checked;
		const promises = [];

		document.querySelectorAll('.js-request-row').forEach(row => {
			if (row.style.display !== 'none') {
				const cb = row.querySelector('.request-checkbox');
				if (cb) {
					cb.checked = isChecked;
					promises.push(updateSelection(cb.value, isChecked));
				}
			}
		});

		await Promise.all(promises);
		updateToggleAllState();
	}

	// Обновление состояния "Выделить все"
	function updateToggleAllState() {
		const visibleCheckboxes = Array.from(document.querySelectorAll(REQUEST_ROW_SELECTOR))
			.filter(row => row.style.display !== 'none')
			.map(row => row.querySelector(REQUEST_CHECKBOX_SELECTOR));

		if (visibleCheckboxes.length === 0) {
			toggleAll.checked = false;
			toggleAll.indeterminate = false;
			return;
		}

		const checkedCount = visibleCheckboxes.filter(cb => cb.checked).length;
		toggleAll.checked = checkedCount === visibleCheckboxes.length;
		toggleAll.indeterminate = checkedCount > 0 && checkedCount < visibleCheckboxes.length;

		if (!btnSelectToday) return;

		if (checkedCount) {
			btnSelectToday.disabled = false
			btnSelectToday.style.opacity = 1
		} else {
			btnSelectToday.disabled = true
			btnSelectToday.style.opacity = 0.5
		}
	}

	// Поиск с фильтрацией (с debounce)
	let searchTimeout;
	function handleSearch() {
		clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			const searchTerm = this.value.toLowerCase();

			document.querySelectorAll(REQUEST_ROW_SELECTOR).forEach(row => {
				const checkbox = row.querySelector(REQUEST_CHECKBOX_SELECTOR);
				if (!checkbox) return;

				const searchData = JSON.parse(checkbox.dataset.searchText || '{}');
				const textToSearch = Object.values(searchData).join(' ').toLowerCase();
				row.style.display = textToSearch.includes(searchTerm) ? '' : 'none';
			});

			updateToggleAllState();
		}, 300);
	}

	// Отправка формы
	async function handleSubmit(e) {
		e.preventDefault();
		const form = e.target;
		const submitBtn = e.submitter;

		if (!submitBtn) return;

		submitBtn.classList.add('btn--load');
		form.dataset.skipLoader = 'true';

		try {
			if (submitBtn.name === 'done_today') {
				window.location.href = '/repair/done_today/';
			} else if (submitBtn.name === 'ya_map') {
				window.location.href = '/repair/map/';
			} else if (submitBtn.name === 'select_today') {
				const visibleChecked = Array.from(document.querySelectorAll(`${REQUEST_ROW_SELECTOR}:not([style*="none"]) ${REQUEST_CHECKBOX_SELECTOR}:checked`));

				if (visibleChecked.length === 0) {
					alert('Выберите хотя бы одну заявку');
					return;
				}

				const ids = visibleChecked.map(el => el.value);

				const response = await BX.ajax.runComponentAction('main:repair', 'updatePlan', {
					mode: 'ajax',
					data: { ids }
				});

				if (response.status === 'success') {
					// Дать обратную связь
					alert('Заявки успешно добавлены в план на сегодня');

					// Сбросить выбор
					// document.querySelectorAll(REQUEST_CHECKBOX_SELECTOR).forEach(cb => cb.checked = false);
					// updateToggleAllState();
					window.location.href = '/repair/';
				} else {
					alert('Произошла ошибка при обновлении');
				}
			}
		} catch (error) {
			console.error('Ошибка при отправке формы:', error);
			alert('Произошла ошибка');
		} finally {
			submitBtn.classList.remove('btn--load');
		}
	}

	// Инициализация событий
	// searchInput.addEventListener('input', handleSearch);
	toggleAll.addEventListener('change', handleToggleAll);
	form.addEventListener('change', handleCheckboxChange);
	form.addEventListener('submit', handleSubmit);

	// Восстановление состояния
	updateToggleAllState();
});